Ember.Route.reopen({
 activate: function(){
   if( this.get('isLeafRoute') ){
     PegasusTemplate.set('lastLeaf', this.get('routeName') );
   }
   this._super();
 },
 isLeafRoute: function(){
    return PegasusTemplate.Router.router.recognizer.names &&
      PegasusTemplate.Router.router.recognizer.names.hasOwnProperty( this.get('routeName') );
  }.property()
});
